<mat-toolbar color="primary" class="action-toolbar">
    <button mat-icon-button (click)="returnToParent()" matTooltip="Back"><mat-icon
            color="primary">arrow_back_ios</mat-icon></button>
    <h3>Schedule Event</h3>
    <div>
        <button mat-icon-button *ngIf="editingEvent && editingEvent.id" (click)="deleteEvent()"
            matTooltip="Delete Event"><mat-icon color="warn">delete</mat-icon></button>

        <button mat-icon-button [disabled]="form.invalid" (click)="saveEvent()" matTooltip="Save Event"><mat-icon
                [color]="form.invalid ? '' : 'primary'">save</mat-icon></button>
    </div>
</mat-toolbar>

<div class="appointment-details-container">
    <form [formGroup]="form">
        <mat-card>
            <p class="series-note" *ngIf="isSeries && occurrenceDate">
                <mat-icon>repeat</mat-icon>
                <span>Part of a repeating event. Saving asks which events to change.</span>
            </p>

            <mat-form-field appearance="outline">
                <mat-label>Event Title</mat-label>
                <input matInput formControlName="reason">
            </mat-form-field>

            <div class="toggle-container">
                <mat-slide-toggle formControlName="isAllDay" color="primary" (change)="toggleAllDay($event)">All
                    Day</mat-slide-toggle>
                <mat-slide-toggle formControlName="showAsBusy" color="primary"
                    matTooltip="A busy event fills every booking slot it overlaps">Show as busy</mat-slide-toggle>
            </div>

            <div class="date-time-row">
                <mat-form-field appearance="outline">
                    <mat-label>Start Date</mat-label>
                    <input matInput [matDatepicker]="startDatePicker" formControlName="startDate" [min]="todayDate"
                        placeholder="DD/MM/YYYY" (dateChange)="setDefaultEndDate($event)">
                    <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #startDatePicker></mat-datepicker>
                </mat-form-field>

                <mat-form-field appearance="outline" *ngIf="form.get('isAllDay')?.value === false">
                    <mat-label>Start Time</mat-label>
                    <input matInput formControlName="startTime" [ngxTimepicker]="startTimePicker" [format]="24">
                    <ngx-material-timepicker #startTimePicker [theme]="darkTheme" [appendToInput]="true"
                        [preventOverlayClick]="true"></ngx-material-timepicker>
                </mat-form-field>
            </div>

            <div class="date-time-row">
                <mat-form-field appearance="outline">
                    <mat-label>End Date</mat-label>
                    <input matInput [matDatepicker]="endDatePicker" formControlName="endDate"
                        [min]="form.get('startDate')?.value || todayDate" placeholder="DD/MM/YYYY">
                    <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #endDatePicker></mat-datepicker>
                </mat-form-field>

                <mat-form-field appearance="outline" *ngIf="form.get('isAllDay')?.value === false">
                    <mat-label>End Time</mat-label>
                    <input matInput formControlName="endTime" [ngxTimepicker]="endTimePicker" [format]="24">
                    <ngx-material-timepicker #endTimePicker [theme]="darkTheme" [appendToInput]="true"
                        [preventOverlayClick]="true"></ngx-material-timepicker>
                </mat-form-field>
            </div>
            <p class="form-error" *ngIf="form.hasError('invalidEndDate')">The end date is before the start date.</p>
            <p class="form-error" *ngIf="form.hasError('invalidEndTime')">End time must be after start time.</p>
            <p class="hint" *ngIf="form.get('isAllDay')?.value === false">
                Over several days the event runs from the start time on the first day to the end time on the last.
                To hold the same hours each day, repeat it daily.
            </p>

            <mat-form-field appearance="outline" *ngIf="calendarSplitByPhysician">
                <mat-label>Physician</mat-label>
                <mat-select formControlName="physicianId">
                    <mat-option [value]="''">Whole practice</mat-option>
                    <mat-option *ngFor="let user of physicians" [value]="user.userId">{{user.title}} {{user.name}}
                        {{user.surname}}</mat-option>
                </mat-select>
                <mat-hint>Only this physician's slots are held</mat-hint>
            </mat-form-field>

            <ng-container formGroupName="repeat">
                <mat-form-field appearance="outline">
                    <mat-label>Repeat</mat-label>
                    <mat-select formControlName="repeat">
                        <mat-option value="none">Does not repeat</mat-option>
                        <mat-option value="daily">Daily</mat-option>
                        <mat-option value="weekly">Weekly</mat-option>
                        <mat-option value="monthly">Monthly on the same date</mat-option>
                    </mat-select>
                </mat-form-field>

                <div class="repeat-details" *ngIf="repeatChoice !== 'none'">
                    <div class="repeat-every">
                        <span>Every</span>
                        <mat-form-field appearance="outline" class="narrow">
                            <input matInput type="number" min="1" max="99" formControlName="interval" aria-label="Repeat every">
                        </mat-form-field>
                        <span>{{ repeatUnit }}</span>
                    </div>

                    <mat-button-toggle-group *ngIf="repeatChoice === 'weekly'" formControlName="weekdays" multiple
                        class="weekday-toggles" aria-label="Repeat on">
                        <mat-button-toggle *ngFor="let day of weekdays" [value]="day.code">{{ day.label }}</mat-button-toggle>
                    </mat-button-toggle-group>

                    <mat-radio-group formControlName="ends" class="repeat-ends" aria-label="Ends">
                        <mat-radio-button value="never">Never ends</mat-radio-button>
                        <div class="end-option">
                            <mat-radio-button value="on">Ends on</mat-radio-button>
                            <mat-form-field appearance="outline" class="end-field" *ngIf="repeatEnds === 'on'">
                                <input matInput [matDatepicker]="untilPicker" formControlName="until"
                                    [min]="form.get('startDate')?.value" placeholder="DD/MM/YYYY" aria-label="End date">
                                <mat-datepicker-toggle matSuffix [for]="untilPicker"></mat-datepicker-toggle>
                                <mat-datepicker #untilPicker></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="end-option">
                            <mat-radio-button value="after">Ends after</mat-radio-button>
                            <ng-container *ngIf="repeatEnds === 'after'">
                                <mat-form-field appearance="outline" class="narrow">
                                    <input matInput type="number" min="1" max="999" formControlName="count" aria-label="Number of times">
                                </mat-form-field>
                                <span>times</span>
                            </ng-container>
                        </div>
                    </mat-radio-group>

                    <p class="hint">{{ repeatSummary }}</p>
                </div>
            </ng-container>

            <ng-container *ngIf="form.get('isAllDay')?.value === true">
                <p>Event Colors</p>
                <div class="color-fields p-b-20">
                    <ngx-colors matTooltip="Set background color for this event" ngx-colors-trigger
                        formControlName="backgroundColor" [hideTextInput]="true" class="m-r-5"></ngx-colors>

                    <ngx-colors matTooltip="Set text color for this event" ngx-colors-trigger
                        formControlName="textColor" [hideTextInput]="true"></ngx-colors>
                </div>
            </ng-container>

            <mat-form-field appearance="outline">
                <mat-label>Virtual Meeting Link</mat-label>
                <input matInput formControlName="virtualLink">
            </mat-form-field>

        </mat-card>
    </form>
</div>
